export default "__VITE_ASSET__D$ihA4_f__"